import './assets/styles/global.css'
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, CssBaseline } from "@mui/material";
import App from './App';
import reportWebVitals from './reportWebVitals';
import theme from './assets/styles/theme';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(

<ThemeProvider theme={theme}>
    <CssBaseline /> {/* Resets default styling */}
    <App />
  </ThemeProvider>,




);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
